import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { SystemTemplate } from 'models/automation/SystemTemplates';
import API from 'services/API';
import { SYSTEM_TEMPLATES_BASE_QUERY_KEY } from './useFetchSystemTemplates';

type ReactQueryOptions = Omit<
  UseQueryOptions<SystemTemplate | null>,
  'queryKey' | 'queryFn'
>;

type UseFetchSystemTemplateArgs = ReactQueryOptions & {
  systemTemplateUid?: string | null;
};

const useFetchSystemTemplate = ({
  enabled = true,
  systemTemplateUid,
  ...options
}: UseFetchSystemTemplateArgs) => {
  return useAppQuery<SystemTemplate | null>({
    queryKey: [SYSTEM_TEMPLATES_BASE_QUERY_KEY, 'detail', systemTemplateUid],
    queryFn: async () => {
      const response = await API.get<SystemTemplate>(
        `/api/internal/automation/system-templates/uid/${systemTemplateUid}`,
      );

      return response.data;
    },
    enabled,
    staleTime: 30000,
    ...options,
  });
};

export default useFetchSystemTemplate;
